// Locale-aware path + share-link helpers for the whole public site. Indonesian
// pages live under a /id prefix; English at the root.

const prefix = (language) => (language === "id" ? "/id" : "");

// The HostelNMC brand page. "" would resolve to the current directory, so the
// root has to be spelled "/" explicitly.
export const brandHome = (language) => prefix(language) || "/";

export const propertyHome = (language) => `${prefix(language)}/hebe`;

// The property story: about, facilities, rooms and the gallery. Moved off /hebe so the landing page
// can be about booking.
export const propertyAbout = (language) => `${prefix(language)}/hebe/about`;

// Instagram + TikTok. Only linked when AppSetting hebe.stories_enabled is on.
export const propertyStories = (language) => `${prefix(language)}/hebe/stories`;

export const roomPath = (language, slug) =>
  `${prefix(language)}/hebe/rooms/${slug}`;

// The in-house guest portal. Deliberately NOT locale-prefixed: it redirects into
// the HGS app, which lives outside the bilingual marketing routes — there is no
// /id/hebe/inhouse and linking to one would 404.
export const guestPortal = () => "/hebe/inhouse";

export const privacyPath = (language) =>
  `${prefix(language)}/hebe/privacy-policy`;

export const termsPath = (language) =>
  `${prefix(language)}/hebe/terms-of-service`;

export const insightsHome = (language) => `${prefix(language)}/insights`;

export const categoryPath = (language, slug) =>
  `${prefix(language)}/insights/c/${slug}`;

export const insightPath = (language, slug) =>
  `${prefix(language)}/insights/${slug}`;

export const shareLinks = (url, title) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  return {
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    x: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    line: `https://social-plugins.line.me/lineit/share?url=${u}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${u}&description=${t}`,
    email: `mailto:?subject=${t}&body=${u}`,
  };
};
